// Tipos de una Actividad, compartidos por el Programa y el Diseno Instruccional.
//
// En la tabla del Programa una Actividad figura SIEMPRE con el tipo "Actividad" (4). Que ademas
// sea Formativa o Sumativa es su subtipo, y no vive en el wrapper sino en el EvaluationTypeDefault
// del Evaluation de evaluations2. Se ve dentro del modulo de evaluaciones y en el DI, no en la
// columna Tipo del Programa.
//
// Las dos vistas llegan al subtipo por caminos distintos y por eso conviven aca:
//   · Diseno Instruccional -> el usuario lo responde: "¿Posee Ponderacion?".
//   · Programa             -> ese formulario no lo pregunta, asi que se deduce de si pondera.
//
// Lo que NO esta aca es la creacion de la InstructionalActivity: la hace el backend en un
// post_save de los wrappers (teaching/signals.py), junto al resto de las invariantes
// Actividad-Evaluacion, para que valga tambien fuera de la vista.

// Tipo del wrapper (MatterEvaluation / EgressProfileMatterEvaluation).
export const WRAPPER_TYPE_ACTIVITY = 4;

// E24 elimino `WRAPPER_TYPES_OWNED_BY_DESIGN`. Existia para normalizar a "Actividad" el tipo de
// una evaluacion enlazada, y tenia sentido cuando lo unico que podia estar enlazado al DI era una
// Actividad: servia para reparar filas viejas. Desde que el DI tambien REFERENCIA las evaluaciones
// del Programa, un wrapper tipo 3 enlazado ya no es una fila por reparar, es una Sumativa legitima:
// re-tiparla al guardar la habria convertido en Actividad sin que nadie lo pidiera. El DI fija el
// tipo solo cuando el mismo crea el wrapper (`createEvaluationForActivity`), nunca al actualizar.

// Tipos de EvaluationTypeDefault (evaluations2). Ojo: NO coinciden con los del wrapper.
export const EVALUATION_TYPE_SUMMATIVE = 1;
export const EVALUATION_TYPE_FORMATIVE = 3;

// Subtipo deducido de la ponderacion. Es el camino del Programa; el DI usa la respuesta explicita
// del formulario, que da lo mismo salvo que alguien marque Sumativa con 0%.
export function activityEvaluationType(weighing) {
    return Number(weighing) > 0 ? EVALUATION_TYPE_SUMMATIVE : EVALUATION_TYPE_FORMATIVE;
}
